module.exports = (minimum, maximum) => {
  let nums = {},
    iterations = 0;
  const count = maximum - minimum;

  return function random() {
    const a = Math.floor(Math.random() * (maximum - minimum + 1) + minimum);

    if (count === iterations) {
      nums = {};
      iterations = 0;
    }
    iterations++;

    if (!!nums[a]) {
      return random();
    } else {
      nums[a] = 1;
      return a;
    }
  };
};
